import { createSlice } from '@reduxjs/toolkit';
import { createMongoAbility } from '@casl/ability';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: null,
    token: null,
    status: 'offline',
    onlineStatuses: {},
    announcementStatus: false,
    gnnStatus: false,
    eventsStatus: false,
    chatStatus: false,
    feedbackStatus: false,
    team: null,
    group: null,
    permissions: null,
    viewportHeight: 350,
    viewportWidth: 680,
    scale: 1,
    fcmToken: "",
    deviceType: "",
    deviceVersion: "",
    notificationNewsId: "",
  },
  reducers: {
    setCredentials: (state, action) => {
      const { user, accessToken } = action.payload;
      state.user = user;
      state.token = accessToken;
      state.status = 'online';
    },
    setAccessToken: (state, action) => {
      const { accessToken } = action.payload;
      if (state.user) {
        state.token = accessToken;
      } else {
        state.token = null;
      }
    },
    logout: (state, action) => {
      state.user = null;
      state.token = null;
      state.status = 'offline';
      state.onlineStatuses = {};
      state.announcementStatus = false;
      state.gnnStatus = false;
      state.eventsStatus = false;
      state.team = null;
      state.permissions = null;
      state.group = null;
      state.viewportWidth = 350;
      state.viewportHeight = 680;
      state.scale = 1;
    },
    setCurrentTeam: (state, action) => {
      const { team } = action.payload;
      state.team = team;
    },
    setCurrentGroups: (state, action) => {
      const { group } = action.payload;
      state.group = group;
    },
    setCurrentUserStatus: (state, action) => {
      const status = action.payload;
      state.status = status;
    },
    updateUserStatus: (state, action) => {
      const { empCode, status } = action.payload;
      state.onlineStatuses[empCode] = status;
    },
    setOnlineUsers: (state, action) => {
      state.onlineStatuses = action.payload;
    },
    setAnnouncementStatus: (state, action) => {
      state.announcementStatus = action.payload;
    },
    setGnnStatus: (state, action) => {
      state.gnnStatus = action.payload;
    },
    setEventsStatus: (state, action) => {
      state.eventsStatus = action.payload;
    },
    setPermissions: (state, action) => {
      state.permissions = action.payload;
    },
    setChatStatus: (state, action) => {
      state.chatStatus = action.payload;
    },
    setFeedbackStatus: (state, action) => {
      state.feedbackStatus = action.payload;
    },
    setLayout: (state, action) => {
      state.user.layout = action.payload;
    },
    setViewportHeight: (state, action) => {
      state.viewportHeight = action.payload;
    },
    setViewportWidth: (state, action) => {
      state.viewportWidth = action.payload;
    },
    setScale: (state, action) => {
      state.scale = action.payload;
    },
    setFcmToken: (state, action) => {
      state.fcmToken = action.payload;
    },
    setDeviceType: (state, action) => {
      state.deviceType = action.payload
    },
    setDeviceVersion: (state, action) => {
      state.deviceVersion = action.payload;
    },
    setNotificationNewsId: (state, action) => {
      state.notificationNewsId = action.payload
    }
  },
});

export const {
  setCredentials,
  setAccessToken,
  logout,
  setCurrentTeam,
  setCurrentGroups,
  setCurrentUserStatus,
  updateUserStatus,
  setOnlineUsers,
  setAnnouncementStatus,
  setGnnStatus,
  setEventsStatus,
  setPermissions,
  setChatStatus,
  setFeedbackStatus,
  setLayout,
  setViewportHeight,
  setViewportWidth,
  setScale,
  setFcmToken,
  setDeviceType,
  setDeviceVersion,
  setNotificationNewsId
} = authSlice.actions;

export default authSlice.reducer;

export const selectCurrentUser = (state) => state.auth.user;
export const selectCurrentUserToken = (state) => (state.auth.user ? state.auth.token : null);
export const selectCurrentPermissions = (state) => state.auth.permissions || [];
export const selectCurrentUserId = (state) => state.auth.user.id;
export const selectCurrentUserEmpCode = (state) => state.auth.user?.empCode;
export const selectCurrentTeam = (state) => state.auth.team;
export const selectCurrentToken = (state) => state.auth.token;
export const selectCurrentUserStatus = (state) => state.auth.status;
export const selectUserStatus = (state, empCode) => state.auth?.onlineStatuses[empCode] || 'offline';
export const selectUserSatuses = (state) => state.auth?.onlineStatuses;
export const selectAnnouncementStatus = (state) => state.auth?.announcementStatus;
export const selectGnnStatus = (state) => state.auth?.gnnStatus;
export const selectEventsStatus = (state) => state.auth?.eventsStatus;
export const selectChatsStatus = (state) => state.auth?.chatStatus;
export const selectFeedbackStatus = (state) => state.auth?.feedbackStatus;
export const selectViewportWidth = (state) => state.auth?.viewportWidth;
export const selectViewportHeight = (state) => state.auth?.viewportHeight;
export const selectViewportScale = (state) => state.auth?.scale;
export const selectCurrentGroups = (state) => state.auth?.group;
export const selectFcmToken = (state) => state.auth?.fcmToken;
export const selectDeviceType = (state) => state.auth?.deviceType;
export const selectNotificationNewsId = (state) => state.auth?.noitificationNewsId;
export const selectDeviceVersion = (state) => state.auth?.deviceVersion;
